import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SmallLoadingIndicator from 'atoms/SmallLoadingIndicator';
import { generateToast } from 'containers/App/actions';
import { loadAllClients } from 'containers/CliniciansAndClients/actions';

import AccountCreationCard from './AccountCreationCard';
import PatientActionsCard from './PatientActionsCard';
import { getOQProfile } from './actions';

const MeasureCard = (): JSX.Element => {
	const dispatch = useDispatch();

	const userId = useSelector((state: RootState) =>
		state.get('app').get('auth').get('loggedInUser').get('id'),
	);
	const userName = useSelector((state: RootState) =>
		state.get('app').get('auth').get('loggedInUser').get('name'),
	);

	const {
		isFetchingProfile,
		hasOQAccount,
		isCreatingEmployee,
		errorMessage,
		successMessage,
	} = useSelector((state: RootState) => state.get('measures').toJS());

	useEffect(() => {
		dispatch(loadAllClients());
		if (!hasOQAccount) {
			// Don't check for OQ account again if already succeeded
			dispatch(getOQProfile({ userId: userId.toString() }));
		}
	}, []);

	useEffect(() => {
		if (errorMessage) {
			dispatch(generateToast({ type: 'custom-error', text: errorMessage }));
		}
	}, [errorMessage]);

	useEffect(() => {
		if (successMessage) {
			dispatch(generateToast({ type: 'custom-success', text: successMessage }));
		}
	}, [successMessage]);

	return (
		<div className="px-0">
			<div className="d-flex mb-3">
				<a
					className="border bg-white p-4 font-13 font-weight-bold text-decoration-none filter-nav"
					style={{ color: 'inherit' }}
					href="https://www.oqanalyst.com/Mind-Therapy-Clinic/"
					target="_blank"
					rel="noreferrer noopener"
				>
					OQ Analyst Measures
				</a>
			</div>
			<div>
				{isFetchingProfile || isCreatingEmployee ? (
					<div className="w-100 pb-4 bg-white">
						<SmallLoadingIndicator
							text="Loading..."
							color="var(--main-color)"
						/>
					</div>
				) : hasOQAccount ? (
					<>
						<div className="card bg-white p-3 w-100 mx-0 mb-2 d-flex flex-row align-items-center justify-content-between">
							<div className="d-flex flex-column">
								<span className="font-weight-bold font-12 text-uppercase text-muted">
									Your OQ Analyst account
								</span>
								<span className="font-13">{userName || 'Active'}</span>
							</div>
						</div>
						<PatientActionsCard />
					</>
				) : (
					<AccountCreationCard />
				)}
			</div>
		</div>
	);
};

export default MeasureCard;
